/* @flow */
import { prefillMessageWithGroupName } from 'utils/prefillMessageWithGroupName';
import gql from 'graphql-tag';
import GroupStore from 'groups/stores/GroupStore';
import RemindAPI from 'lib/RemindAPI';
import { TARGET_TYPES } from 'entities/Message';
import type { Target } from 'entities/Message';

export async function getInitialAnnouncementTextForGroup(
  groupCode: string,
  target?: ?Target
): Promise<string> {
  const group = GroupStore.getGroupForCode(groupCode);

  if (!group) {
    return '';
  }

  const groupUuid = group.getUuid();
  const org = group.getOrganization();
  const orgUuid = org ? org.get('uuid') : '';
  const isOrganizationTarget = target ? target.type === TARGET_TYPES.ORGANIZATION_TARGET : false;
  const streamUuid = isOrganizationTarget ? orgUuid : groupUuid;

  const entityStreamIsEmpty = await RemindAPI.execute({
    query: gql`
      query getInitialAnnouncementTextForGroup($uuid: String!) {
        entityStreams(uuids: [$uuid]) {
          uuid
          sequenceItems {
            key
          }
        }
      }
    `,
    variables: { uuid: streamUuid },
    forceFetch: true,
  }).then(
    res => res.entityStreams[0].sequenceItems.length === 0,
    err => {
      console.error('entityStreams query failure in getInitialAnnouncementTextForGroup');
      console.warn(err);
      return false;
    }
  );

  if (entityStreamIsEmpty) {
    return prefillMessageWithGroupName(group.getName());
  }

  return '';
}
